/******************************************************************************
 * App configuration
 *****************************************************************************/
export const APP_NAME =
    "Zählerstand Zähler ablesen - Eure Stadtwerke Glückstadt";
export const APP_SHORT_NAME = "Ableseportal";
export const APP_DESCRIPTION =
    "Geben Sie uns Ihren Zählerstand einfach online durch!";
export const CLIENT_FULL = "Stadtwerke Glückstadt GmbH";
export const CLIENT_SHORT = "Stadtwerke Glückstadt";
export const FALLBACK_PRECOMMA_DIGITS = 7;
export const URLS = {
    website: "https://stadtwerke-glueckstadt.de",
    privacy: "https://stadtwerke-glueckstadt.de/datenschutz/",
    imprint: "https://stadtwerke-glueckstadt.de/impressum/",
};
export const LENGTH_IMPLAUSIBLE_REASON_OTHER = 200;
export const ERROR_MESSAGES = {
    error429: "😡 Zuviele Anfragen. Bitte versuchen Sie es in Kürze erneut.",
    error500:
        "😓 Beim Verarbeiten Ihrer Anfrage ist ein Fehler aufgetreten. Bitte kontaktieren Sie unseren Kundenservice.",
};
